import React, { Component } from 'react';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import '../style.css'


class NavBar extends Component {
  render() {
    return (
      <Navbar fluid fixedTop inverse collapseOnSelect>
        <Navbar.Header>
          <Navbar.Brand >
            <a href='/'><p className='navbarTxt'>Luke Hendrick</p></a>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav id="myNavbar" pullRight>
            <ul className="nav navbar-nav navbar-right navItem">
              <NavItem className='navItem' href="#section1">About</NavItem>
              <NavItem href="#section2">Portfolio</NavItem>
              <NavItem href="#section3">Contact</NavItem>
            </ul>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/Nav.js